export default __webpack_public_path__ + "static/media/mi.a5fb64e1.png";